import React from 'react';

export default function LoadingSpinner({ color = 'border-sky-600' }) {
  return (
    <div className="flex justify-center py-4">
      <div className={`animate-spin rounded-full h-8 w-8 border-b-2 ${color}`}></div>
    </div>
  );
} 